<div class="k-overlay" *ngIf="dialogAddAssessmentOpened"></div>
<kendo-window #window [width]="1000" *ngIf="dialogAddAssessmentOpened" (close)="openDialog()" [height]="775"
  style="position:fixed" [state]="windowState" [top]="60" (resized)="onResized($event)"
  (stateChange)="onStateChange($event)">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{'ADD-ASSESSMENT' | translate}}</h3>
    </div>
    <button kendoWindowMaximizeAction attr.aria-label="{{'MAXIMIZE' | translate}}"></button>
    <button kendoWindowRestoreAction attr.aria-label="{{'RESTORE' | translate}}"></button>
    <button kendoWindowCloseAction attr.aria-label="{{'CLOSE' | translate}}"></button>
  </kendo-window-titlebar>
  <form [formGroup]="assessmentForm">
    <kendo-tabstrip #tabstrip (tabSelect)="onSelectTab($event)">
      <kendo-tabstrip-tab title="{{ 'CONTACT' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="k-form max-form-width">
            <div class="row">
              <div class="col-4">
                <label class="pt-2">
                  <span class="k-text-uppercase dark">
                    {{'ASSESSOR' | translate}}
                  </span>
                </label>
              </div>
              <div class="col-8">
                <i class="fas fa-user fa-1_5x mr-2"></i>{{assessor}}
              </div>
            </div>
            <label class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ASSESSMENT-DATE' | translate}} *
                  </span>
                </label>
              </div>
              <div class="col-8">
                <kendo-datepicker class="w-50" [format]="g" [max]="maxDate" formControlName="assessmentDate" required
                  attr.aria-label="{{'ASSESSMENT-DATE' | translate}}">
                </kendo-datepicker>
                <div class="k-tooltip k-tooltip-validation mb-2" role="alert"
                  style="display:inline-block;position: static;"
                  *ngIf="assessmentDate.invalid && assessmentDate.touched">
                  {{'ASSESSMENT-DATE-REQUIRED' | translate}}
                </div>
              </div>
            </label>
            <label class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ASSESSMENT' | translate}} *
                  </span>
                </label>
              </div>
              <div class="col-7">
                <kendo-combobox id="type" formControlName="assessment" class="w-100" [valuePrimitive]="false"
                  [filterable]="true" (filterChange)="assessmentFilter($event)" (close)="searchTerm=''"
                  [itemDisabled]="itemDisabled" [data]="assessmentsFiltered" [textField]="'name'" [valueField]="'id'"
                  attr.aria-label="{{ 'ASSESSMENT' | translate }}">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                    </span>
                  </ng-template>
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation mb-2" role="alert"
                  style="display:inline-block;position: static;" *ngIf="assessment.invalid && assessment.touched">
                  {{'ASSESSMENT-REQUIRED' | translate}}
                </div>
              </div>
              <div class="col-1 text-center mt-2">
                <i *ngIf="assessmentTabVisible() && assessment !== undefined && assessment.value.source === 'STATIC'"
                  class="fas fa-download fa-lg" title="{{ 'ASSESSMENT-DOWNLOAD-TEMPLATE' | translate }}"
                  (click)="downloadTemplate(assessment.value)" role="button"
                  attr.aria-label="{{ 'ASSESSMENT-DOWNLOAD-TEMPLATE' | translate }}" tabindex="0"
                  (keydown.enter)="downloadTemplate(assessment.value)"
                  (keydown.space)="downloadTemplate(assessment.value)">
                </i>
              </div>
            </label>
            <!--Contact Entity-->
            <label class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CONTACT-HISTORY-ENTITY' | translate}} *
                  </span>
                </label>
              </div>
              <div class="col-7">
                <kendo-combobox id="contactEntity" formControlName="contactEntity" [data]="contactEntities"
                  [textField]="'displayName'" [valueField]="'id'" class="w-100 keyboard-accessible" tabindex="0"
                  attr.aria-label="{{'CONTACT-HISTORY-ENTITY' | translate}}">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
                  </ng-template>
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation mb-2" role="alert"
                  style="display:inline-block;position: static;" *ngIf="contactEntity.invalid && contactEntity.touched">
                  {{'CONTACT-ENTITY-REQUIRED' | translate}}
                </div>
              </div>
            </label>
            <!--Contact Method-->
            <label class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CONTACT-HISTORY-METHOD' | translate}} *
                  </span>
                </label>
              </div>
              <div class="col-8">
                <kendo-combobox id="contactMethod" formControlName="contactMethod" [data]="contactMethods"
                  [textField]="'displayName'" [valueField]="'id'" class="w-50 keyboard-accessible" tabindex="0"
                  attr.aria-label="{{'CONTACT-HISTORY-METHOD' | translate}}">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
                  </ng-template>
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert" style="display:inline-block;position: static;"
                  *ngIf="contactMethod.invalid && contactMethod.touched">
                  {{'CONTACT-METHOD-REQUIRED' | translate}}
                </div>
              </div>
            </label>
            <!--Comments-->
            <div class="row mb-2">
              <div class="col-12">
                <label for="comments" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'COMMENTS' | translate }}
                  </span>
                  <textarea kendoTextArea class="w-100" cols="120" rows="3" formControlName="assessmentComments"
                    maxlength="4000" attr.aria-label="{{ 'COMMENTS' | translate }}"
                    style="max-height: 200px;min-height: 38px;">
                  </textarea>
                </label>
              </div>
            </div>
            <div class="row k-form" *ngIf="showMood">
              <input type="checkbox" id="addMood" formControlName="addMood" kendoCheckBox />
              <label class="k-checkbox-label k-text-uppercase dark" for="addMood">{{ 'ASSESSMENT-ADD-MOOD' | translate
                }}</label>
            </div>
            <div class="row k-form">
              <input type="checkbox" id="addFlag" formControlName="addFlag" kendoCheckBox />
              <label class="k-checkbox-label k-text-uppercase dark" for="addFlag">{{ 'ASSESSMENT-ADD-FLAG' | translate
                }}</label>
            </div>
            <div class="row k-form" *ngIf="!hasTask()">
              <input type="checkbox" id="addFollowUpTask" formControlName="addFollowUpTask" kendoCheckBox />
              <label class="k-checkbox-label k-text-uppercase dark" for="addFollowUpTask">{{
                'ASSESSMENT-ADD-FOLLOW-UP-TASK' | translate }}
              </label>
            </div>
          </div>
          <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'ASSESSMENT' | translate }}" [disabled]="!assessmentTabVisible()">
        <ng-template kendoTabContent>
          <!--Form Type Template-->
          <div *ngIf="isFormTemplate()" class="form-content" #survey>
            <div [ngSwitch]="isShowMemberExtension()">
              <!--Show formly without patient extension-->
              <form #formlyDiv *ngSwitchCase="false" [formGroup]="formFulfillment" class="k-form ml-2 mr-2"
                [ngStyle]="{'max-height': maxWindowHeight+'px'}">
                <formly-form [form]="formFulfillment" [fields]="fields" [model]="model"></formly-form>
              </form>
              <!--When isShowMemberExtension is true we display the patient extension on the right splitter pane-->
              <kendo-splitter #splitter *ngSwitchCase="true" orientation="horizontal"
                style="background-color:#f5f6fb; border: none;" (layoutChange)="updateSplitterBar()">
                <kendo-splitter-pane class="mr-2" size="60%">
                  <form #formlyDiv [formGroup]="formFulfillment" class="k-form ml-2 mr-2"
                    [ngStyle]="{'max-height': maxWindowHeight+'px'}">
                    <formly-form [form]="formFulfillment" [fields]="fields" [model]="model"></formly-form>
                  </form>
                </kendo-splitter-pane>
                <kendo-splitter-pane [collapsible]="true" [resizable]="true">
                  <div class="w-100">
                    <kendo-grid [data]="patViewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                      [sort]="patViewExtensions.state.sort" [resizable]="true" style="max-height: 600px;"
                      [navigable]="true" (dataStateChange)="patExtensionsDataStateChange($event)"
                      [kendoGridSelectBy]="'id'" class="ml-3 mb-2"
                      [ngStyle]="{'max-height': currentMaxExtensionHeight+'px'}">
                      <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}"></kendo-grid-messages>
                      <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
                        [filterable]="false" [sortable]="true">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span title="{{dataItem.displayLabel}}"
                            *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column *ngIf="viewExtensionsShowAlternateValue" field="alternateValue" [width]="40"
                        title="{{ 'ALTERNATE-VALUE' | translate }}">
                      </kendo-grid-column>
                      <kendo-grid-column *ngIf="viewExtensionsShowDisplayName" field="displayName" [width]="65"
                        title="{{ 'DISPLAY-NAME' | translate }}">
                      </kendo-grid-column>
                    </kendo-grid>
                  </div>
                </kendo-splitter-pane>
              </kendo-splitter>
            </div>
          </div>
          <!--File Type Template-->
          <div *ngIf="isFileTemplate()" class="k-form">
            <!--Assessment File Name-->
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FILENAME' | translate}} *
                  </span>
                  <input id="documentName" kendoTextBox formControlName="documentName" />
                  <input class="d-none" type="file" (change)="onFileChanged($event)" #fileInput />
                  <div class="k-tooltip k-tooltip-validation mb-2" role="alert"
                    style="display:inline-block;position: static;"
                    *ngIf="documentName.hasError('required') && documentName.touched">
                    {{'ASSESSMENT-FILE-REQUIRED' | translate}}
                  </div>
                  <button kendoButton type="button" (click)="fileInput.click()" class="mt-3 float-right">
                    {{'SELECT-ASSESSMENT-COMPLETED' | translate}}<i class="far fa-upload fa-white"></i>
                  </button>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'SENTIMENT' | translate }}" *ngIf="moodTabVisible()">
        <ng-template kendoTabContent>
          <div class="k-form tab-content-height max-form-width">
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CONTACT-HISTORY-PATIENT-MOOD' | translate:patientLabel}} {{requiredMood === true ? '*' : ''}}
                  </span>
                </label>
              </div>
              <div class="col-8 contact-history-icons d-flex">
                <a *ngFor="let item of patientMoods" class="contact-mood-{{item.value}}" style="width:16%;"
                  [ngClass]="{'contact-option-selected': item.value === patientMood.value}"
                  (click)="selectPatientMood(item.value)">
                  <input class="d-none" formControlName="patientMood" />
                  <i class="far {{item.icon}} fa-1_5x"></i><br />
                  <span>{{item.text}}</span>
                </a>
              </div>
            </div>
            <!--Comments-->
            <div class="row mt-2">
              <div class="col-sm-4">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'SUMMARY' | translate}}
                  </span>
                </label>
              </div>
              <div class="col-sm-8">
                <textarea kendoTextArea rows="3" class="w-100" formControlName="comments"></textarea>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'FLAG' | translate }}" *ngIf="flagTabVisible()">
        <ng-template kendoTabContent>
          <div class="k-form tab-content-height max-form-width">
            <div class="row">
              <div class="col-5">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CATEGORY' | translate}} *
                  </span>
                </label>
                <kendo-combobox id="category" formControlName="category" [data]="flagCategories"
                  [textField]="'displayName'" [valueField]="'id'" class="w-100" tabindex="1"
                  (valueChange)="getFlags($event,false)">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
                  </ng-template>
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="category.hasError('required') && category.touched">
                  {{ 'CATEGORY-REQUIRED' | translate }}
                </div>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'PRIORITY' | translate}} *
                  </span>
                </label>
                <kendo-combobox id="priority" formControlName="priority" [data]="flagPriorities"
                  [textField]="'displayName'" [valueField]="'id'" class="w-100">
                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <i class="fa fa-circle flag-priority-color-{{dataItem.code}}"></i>
                    &nbsp;{{ dataItem.displayName }}
                  </ng-template>
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="priority.hasError('required') && priority.touched">
                  {{ 'PRIORITY-REQUIRED' | translate }}
                </div>
              </div>
              <div class="col-3 text-center" *ngIf="false">
                <label class="k-form-field text-center">
                  <span class="k-text-uppercase dark">
                    {{'PRIVATE' | translate}}
                  </span>
                </label>
                <kendo-switch formControlName="privacy" onLabel="{{'YES' | translate }}"
                  offLabel="{{'NO' | translate }}">
                </kendo-switch>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FLAG' | translate}} *
                  </span>
                </label>
                <kendo-autocomplete #singleSelect [data]="allFlagsFiltered" [valueField]="'displayName'"
                  [textField]="'displayName'" [virtual]="virtualFlag" class="w-100" [suggest]="true"
                  [highlightFirst]="true" [filterable]="true" (click)="singleSelect.toggle(true)"
                  (filterChange)="filterAllFlags($event)" (close)="searchTerm=''" formControlName="description"
                  tabindex="2">
                  <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                    </span>
                  </ng-template>
                </kendo-autocomplete>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="description.hasError('required') && description.touched">
                  {{ 'FLAG-REQUIRED' | translate }}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px;bottom:auto;background-color:#f5f6fb;"
    class="w-100 mt-3">
    <button kendoButton type="button" (click)="openDialog()">
      {{ 'CANCEL' | translate}}
    </button>
    <button appPreventClick kendoButton type="button" [disabled]="assessmentForm.invalid || creating"
      (click)="createAssessment()">
      {{ (hasTask() ? 'COMPLETE-TASK' : 'SAVE') | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-window>

<!--Close confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="dialogVisible" (close)="cancelAdd(false)"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-ADD-ASSESSMENT-CLOSE' | translate }}</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelAdd(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="cancelAdd(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>